import * as React from 'react';
import { observer } from 'mobx-react';
import { OverBudgetStore } from 'nomst/Stores/Decision/overBudget.store';
import './overBudgetDialog.scss';

export interface IOverBudgetDialogProps {
    overBudgetStore: OverBudgetStore;
    isHrUser?: boolean;
    submitForReview?: () => void;
}

export class OverBudgetDialog extends React.Component<IOverBudgetDialogProps> {
    constructor(props: IOverBudgetDialogProps) {
        super(props);

        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleSubmitForReview = this.handleSubmitForReview.bind(this);
    }

    render(): React.ReactNode {
        const { overBudgetStore, isHrUser } = this.props;
        if (!overBudgetStore.warnOverBudget) {
            return null;
        }

        return (
            <div className="pxl-modal">
                <div className="pxl-modal__content over-budget-dialog">
                    <h3 className="over-budget-dialog__headline">
                        <i className="icon-warning"/>
                        Pay decisions exceed your allocated budget
                    </h3>
                    <p className="over-budget-dialog__body">
                        Please review and adjust your decisions for:
                        <span className="over-budget-dialog__budget-names">{overBudgetStore.overBudgetNames}</span>
                    </p>
                    <div className="over-budget-dialog__actions">
                        {isHrUser && <button
                            onClick={this.handleSubmitForReview}
                            className="pxl-btn over-budget-dialog__override-btn"
                        >
                            Override Budget Rule
                        </button>}
                        <button
                            onClick={this.handleCloseDialog}
                            className="pxl-btn pxl-btn--primary over-budget-dialog__close-btn"
                        >
                            Review Decisions
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    private handleCloseDialog(): void {
        const { overBudgetStore } = this.props;
        overBudgetStore.turnOffOverBudgetWarning();
    }

    private handleSubmitForReview(): void {
        const { submitForReview, overBudgetStore } = this.props;
        if (submitForReview) {
            submitForReview();
        }

        overBudgetStore.turnOffOverBudgetWarning();
    }
}

export default observer(OverBudgetDialog);